import script from "./SaludList.vue?vue&type=script&setup=true&lang=js"
export * from "./SaludList.vue?vue&type=script&setup=true&lang=js"

import "./SaludList.vue?vue&type=style&index=0&id=4a47b9b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a47b9b2"]])

export default __exports__